import { useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { AppState } from '../../declarations/redux';

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
